import { render, staticRenderFns } from "./tenant.vue?vue&type=template&id=21b90102&"
import script from "./tenant.vue?vue&type=script&lang=ts&"
export * from "./tenant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tenant.vue"
export default component.exports